// extracted by mini-css-extract-plugin
module.exports = {"calendar":"CalendarMultiArtist_calendar__HNy6F","loader-container":"CalendarMultiArtist_loader-container__7Q99j"};